import React, { useRef, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Ending.modules.css'; // スタイルを分離して管理
//import bgm from '../assets/ending.mp3'; // BGMファイル
import { SUPER_CHAT } from "../constants/gameConstant"

const Ending = () => {
  const navigate = useNavigate();
  const creditsRef = useRef(null); // エンドロールの内容を参照
  const [isEndReached, setIsEndReached] = useState(false); // 最後に到達したかどうか
  //const audioRef = useRef(null);

  // URLパラメータからスコアを取得
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const score = queryParams.get("score");

  // アニメーション終了時にボタンをフェードイン
  const handleAnimationEnd = () => {
    setIsEndReached(true);
  };

  // useEffect(() => {
  //   // BGMを再生
  //   const audio = audioRef.current;
  //   if (audio) {
  //     audio.play();
  //   }

  //   return () => {
  //     // コンポーネントアンマウント時にBGMを停止
  //     if (audio) {
  //       audio.pause();
  //       audio.currentTime = 0;
  //     }
  //   };
  // }, []);

  const showSuperChatResult = () => {
    const list = [];

    for (let i = 0; i < location.state?.scoreList.length; i++) {
      let superChatBackColor = "";
      let answerColor = "";
      let answerBackColor = "";
      let money = location.state?.scoreList[i];
      let answer = location.state?.typingList[i];

      if (answer === "") {
        answerColor = "blue"
        answer = " コメント失敗(´;ω;｀)"
      }

      if (money >= SUPER_CHAT.PRICE_LEVEL_7) {
        superChatBackColor = "red";
      }
      else if (money >= SUPER_CHAT.PRICE_LEVEL_5) {
        superChatBackColor = "orange";
      }
      else if (money >= SUPER_CHAT.PRICE_LEVEL_3) {
        superChatBackColor = "yellow";
      }
      else if (money >= SUPER_CHAT.PRICE_LEVEL_2) {
        superChatBackColor = "cyan"
      }

      list.push(
        <div class="result">
          <div class="question" style={{ color: answerColor }}>{answer}</div>
          <span class="space"></span>
          <div class="super-chat" style={{ backgroundColor: superChatBackColor }}>¥{money}</div>
        </div>
      )
    }

    return list;
  }


  // ホーム画面に戻る処理
  const handleClose = () => {
    navigate("/");
  };

  return (
    <div className="ending-screen">
      <div className="credits-container">
        <div
          className="credits-content"
          ref={creditsRef}
          onAnimationEnd={handleAnimationEnd} // アニメーション終了時に実行
        >
          <h1>本日の配信は終了しました。</h1>
          <h1>
            <p>スパチャ金額: {score} 円</p>
            <p />
            <p>ご視聴ありがとうございました！</p>
          </h1>
          <h2><br /><p>【スパチャ金額】</p></h2>
          <h3>
            {showSuperChatResult()}
          </h3>
          <h2><br /><p>【スタッフ】</p></h2>
          <h3 class="staff-list">
            <p class="staff"><span class="last-name">水田</span><span class="space"></span><span class="first-name">勝也</span></p><br />
            <p class="staff"><span class="last-name">中島</span><span class="space"></span><span class="first-name">駿介</span></p><br />
            <p class="staff"><span class="last-name">早坂</span><span class="space"></span><span class="first-name">流星</span></p><br />
            <p class="staff"><span class="last-name">廻</span><span class="space"></span><span class="first-name">広大</span></p><br />
            <p class="staff"><span class="last-name">大久保</span><span class="space"></span><span class="first-name">賢人</span></p><br />
            <p class="staff"><span class="last-name">鍛治</span><span class="space"></span><span class="first-name">宏旭</span></p><br />
          </h3>
          <h3>
            <br /><br />
            <p>「いいね」と「チャンネル登録」</p>
            <p>「X(旧Twitter)のフォロー」もよろしくお願いします。</p>
          </h3>
          <h1>
            <br />
            <p>本日はご視聴ありがとうございました。</p>
          </h1>
        </div>

        {isEndReached && (
          <button className="close-button" onClick={handleClose}>
            配信を閉じる
          </button>
        )}
      </div>

      {/* BGM */}
      {/*<audio ref={audioRef} src={bgm} />*/}
    </div>
  );
};

export default Ending;
